import map from 'ramda/src/map'
import over from 'ramda/src/over'
import lensProp from 'ramda/src/lensProp'
import prepend from 'ramda/src/prepend'
import hasIn from 'ramda/src/hasIn'
import FAQ from 'root/src/shared/descriptions/routes/FAQ'
import termsOfService from 'root/src/shared/descriptions/routes/termsOfService'
import privacyPolicy from 'root/src/shared/descriptions/routes/privacyPolicy'
import cookiePolicy from 'root/src/shared/descriptions/routes/cookiePolicy'
import copyrightPolicy from 'root/src/shared/descriptions/routes/copyrightPolicy'
import rulesOfUse from 'root/src/shared/descriptions/routes/rulesOfUse'
import auth from 'root/src/shared/descriptions/routes/auth'
import projects from 'root/src/shared/descriptions/routes/projects'
import accountSettings from 'root/src/shared/descriptions/routes/accountSettings'
import creators from 'root/src/shared/descriptions/routes/creators'
import filterDares from 'root/src/shared/descriptions/routes/filterDares'
import admin from 'root/src/shared/descriptions/routes/admin'
import brand from 'root/src/shared/descriptions/routes/brand'
import smiteGiveaway from 'root/src/shared/descriptions/routes/smiteGiveaway'
import { NOTIFICATIONS_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import renfieldRules from 'root/src/shared/descriptions/routes/renfieldRules'

const routeDescriptions = {
	...FAQ,
	...auth,
	...projects,
	...termsOfService,
	...privacyPolicy,
	...cookiePolicy,
	...copyrightPolicy,
	...rulesOfUse,
	...accountSettings,
	...creators,
	...filterDares,
	...admin,
	...brand,
	...smiteGiveaway,
	...renfieldRules,
}

const commonModules = [NOTIFICATIONS_MODAL_MODULE_ID]

export default map(
	route => (hasIn('variantModules', route)
		? over(
			lensProp('variantModules'),
			map(variant => over(lensProp('modules'), prepend(...commonModules), variant)),
			route,
		)
		: hasIn('experimentVariants', route)
			? over(
				lensProp('experimentVariants'),
				map(variant => over(lensProp('modules'), prepend(...commonModules), variant)),
				route,
			)
			: over(lensProp('modules'), prepend(...commonModules), route)),
	routeDescriptions,
)
